import AlishaHeadshot from "../Media/AlishaHeadshot.png";
import AditiHeadshot from "../Media/AditiHeadshot.png";

export const EcuadorBoard = [
    {
     id: "alisha",
     name: "Alisha",
     image: AlishaHeadshot,
     description: "3rd year",
     major: "Bioengineering"
    },
    {
     id: "aditi",
     name: "Aditi",
     image: AditiHeadshot,
     description: "3rd year",
     major: "Civil Engineering"
    },
];